"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNullish = exports.isNotNullish = exports.isUndefined = exports.isNull = exports.isNumber = exports.isBoolean = exports.isRegExp = exports.isDate = exports.isFunction = exports.isArray = exports.isObject = exports.isString = void 0;
const getTypeString = (elem) => Object.prototype.toString.call(elem);
const isString = (elem) => {
    return getTypeString(elem) === '[object String]';
};
exports.isString = isString;
const isObject = (elem) => {
    return getTypeString(elem) === '[object Object]';
};
exports.isObject = isObject;
const isArray = (elem) => {
    return getTypeString(elem) === '[object Array]';
};
exports.isArray = isArray;
const isFunction = (elem) => {
    return getTypeString(elem) === '[object Function]';
};
exports.isFunction = isFunction;
const isDate = (elem) => {
    return getTypeString(elem) === '[object Date]';
};
exports.isDate = isDate;
const isRegExp = (elem) => {
    return getTypeString(elem) === '[object RegExp]';
};
exports.isRegExp = isRegExp;
const isBoolean = (elem) => {
    return getTypeString(elem) === '[object Boolean]';
};
exports.isBoolean = isBoolean;
const isNumber = (elem) => {
    return getTypeString(elem) === '[object Number]';
};
exports.isNumber = isNumber;
const isNull = (elem) => {
    return getTypeString(elem) === '[object Null]';
};
exports.isNull = isNull;
const isUndefined = (elem) => {
    return getTypeString(elem) === '[object Undefined]';
};
exports.isUndefined = isUndefined;
/**
 * 값이 Nullish가 아님을 보장하는 type guard
 * usage) [undefined,100,2].filter(isNotNullish)
 */
const isNotNullish = (val) => val !== undefined && val !== null;
exports.isNotNullish = isNotNullish;
const isNullish = (val) => !isNotNullish(val);
exports.isNullish = isNullish;
